module.exports = __webpack_public_path__ + "components/page-header/static/surf-badge-0c62c6016111177c1f2430a1fdfe0b6c.svg";